export default {
  type: "roman",
  tagName: "roman",
};
